/**
 * Nutrition Dropdown Constants
 * Simple UI-specific dropdown options that don't come from API
 */

import { DropdownOption } from "@int-traderjoes/ui-components-library";

/**
 * Yes/No dropdown options
 * Used for: Calculate Amounts field
 */
export const YES_NO_OPTIONS: DropdownOption[] = [{
    label: "Yes",
    value: "yes"
}, {
    label: "No",
    value: "no"
}] as const;

/**
 * Nutrient type dropdown options
 * Used in Add Nutrient Modal for filtering between mandatory and optional nutrients
 */
export const NUTRIENT_TYPE_OPTIONS = [
    { label: "Mandatory", value: "mandatory" },
    { label: "Optional", value: "optional" }
] as const;

/** % DV Calculated Based On — 2,000 Calorie Diet + Protein Claim */
export const DV_CALCULATION_BASIS_PROTEIN_CLAIM_VALUE = "2000CalorieDietProteinClaim";
export const DV_CALCULATION_BASIS_PROTEIN_CLAIM_LABEL = "2,000 Calorie Diet + Protein Claim";

export function isProteinClaimDvCalculationBasis(
    dvCalculationBasis: string | undefined | null
): boolean {
    const val = String(dvCalculationBasis ?? "").trim();
    return (
        val === DV_CALCULATION_BASIS_PROTEIN_CLAIM_VALUE ||
        val === DV_CALCULATION_BASIS_PROTEIN_CLAIM_LABEL
    );
}

